import {
  GET_ALL_REPORTS_SUCCESS,
  GET_ALL_REPORTS_FAILED,
  GET_CONDITION_OPTIONS_SUCCESS,
  GET_CONDITION_OPTIONS_FAILED,
  GET_REPORT_BY_ID_SUCCESS,
  GET_REPORT_BY_ID_FAILED,
  ADD_REPORT_SUCCESS,
  ADD_REPORT_FAILED,
  CLEAR_REPORT,
} from "../actions/types";

const initialState = {
  allReports: [],
  optionData: [],
  getReportById: {},
  addReportSuccess: '',
  addReportError: '',
};

const reportReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_REPORTS_SUCCESS:
      return {
        ...state,
        allReports: action.response.body ? action.response.body : [],
      };

    case GET_ALL_REPORTS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
      };

    case GET_CONDITION_OPTIONS_SUCCESS:
      return {
        ...state,
        optionData: action.response.body.labels,
      };

    case GET_CONDITION_OPTIONS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
      };

    case GET_REPORT_BY_ID_SUCCESS:
      return {
        ...state,
        getReportById: action.response.body.report_details[0],
      };

    case GET_REPORT_BY_ID_FAILED:
      return {
        ...state,
        errorMessage: action.message,
      };
    case ADD_REPORT_SUCCESS:
      return {
        ...state,
        addReportSuccess: action.response.body,
      };
    case ADD_REPORT_FAILED:
      return {
        ...state,
        addReportError: action.message,
      };
    case CLEAR_REPORT:
      return {
        ...state,
        addReportError: '',
        addReportSuccess: '',
        allReports: {}
      };

    default:
      return state;
  }
};

export default reportReducers;
